function ValidaCPF(cpf) {
  // console.log(cpf)
  let isValid = false;

  let soma = 0;
  let soma2 = 0;

  const cpfArray = cpf.split("");
  const pesos1 = [10, 9, 8, 7, 6, 5, 4, 3, 2];
  const pesos2 = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2];
  for (let i = 0; i < pesos1.length; i++) {
    soma = soma + Number(cpfArray[i]) * pesos1[i];
  }

  const resto = soma % 11;
  let digitoVerificador = 0;
  if (resto < 2) digitoVerificador = 0;
  else digitoVerificador = 11 - resto;
  if (digitoVerificador === Number(cpfArray[9])) isValid = true;

  for (let j = 0; j < pesos2.length; j++) {
    soma2 = soma2 + Number(cpfArray[j]) * pesos2[j];
  }
  const resto2 = soma2 % 11;
  let digitoVerificador2 = 0;
  if (resto2 < 2) digitoVerificador2 = 0;
  else digitoVerificador2 = 11 - resto2;
  if (digitoVerificador2 === Number(cpfArray[10])) isValid = true;
  else isValid = false;
  // console.log(Number(cpfArray[10]))
  // console.log(digitoVerificador,digitoVerificador2,cpfArray,isValid,soma,soma2,resto,resto2)

  return isValid;
}

export default ValidaCPF;
